import { Box } from "@mui/material";
import React from "react";
import { KeyDrivePrimaryButton } from "../Buttons/KeyDrivePrimaryButton";
import { KeyDriveBodyMin } from "../Fonts/Body/KeyDriveBodyMin";
import { KeyDriveh4Header } from "../Fonts/Headers/KeyDriveh4Header";
import { KeyDriveBodySubtittle } from "../Fonts/Body/KeyDriveBodySubtittle";

interface IEmptyContainerButton {
    text: string;
    icon: React.ReactNode;
    onClick: () => void;
}

interface IEmptyContainer {
    icon: React.ReactNode;
    needAction?: boolean;
    title: string;
    content: string;
    buttonProps?: IEmptyContainerButton;
    needBorder?: boolean;
}

export const EmptyContainer: React.FC<IEmptyContainer> = ({
    icon,
    content,
    title,
    needAction,
    buttonProps,
    needBorder
}) => {
    return (
        <Box
            height="100%"
            minHeight="150px"
            width="100%"
            flexGrow={1}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            borderRadius={needBorder ? "10px" : "0px"}
            border={needBorder ? "1px solid #0000001A" : {}}
        >
            { icon }
            <Box mt="20px">
                <KeyDriveh4Header
                    color="#2D2D2D"
                    needBold
                    needEllipses={false}
                    text={title}
                />
            </Box>
            <Box width={340} textAlign={"center"} mt="4px">
                <KeyDriveBodySubtittle
                    color="#2D2D2D96"
                    needBold={false}
                    needEllipses={false}
                    text={content}
                />
            </Box>
            { needAction && (
                <Box
                    mt="20px"
                >
                    <KeyDrivePrimaryButton
                        startIcon={buttonProps?.icon}
                        onClick={buttonProps?.onClick}
                        height="30px"
                        TextComponent={KeyDriveBodyMin}
                        TextComponentProps={{
                            color: "#FFFFFF",
                            needBold: false,
                            needEllipses: false,
                            text: buttonProps?.text!
                        }}
                    />
                </Box> 
            ) }
        </Box>
    )
}
